import { defineStore } from 'pinia';
import users from '../service/users';
import utils from '../service/utils';

const useUsers = defineStore('user', {
  // arrow function recommended for full type inference
  state: () => {
    const userCacheExpiration = parseInt(localStorage.getItem('users-cache-expiration'));
    const now = new Date().getTime();
    let users = [];
    if (now < userCacheExpiration) {
      users = JSON.parse(window.localStorage.getItem('users')) || [];
    }

    return {
      users,
      sortAscending: false,
      page: 1,
      numberOfPages: 0,
      loading: false,
    };
  },
  actions: {
    sortUsers(key) {
      this.sortAscending = !this.sortAscending;
      let clone = [...this.users];

      clone.sort(utils.alphabeticSorting(key, this.sortAscending));

      this.users = clone;
    },
    async getAllUsers({ force } = { force: false }) {
      try {
        if (this.users.length && !force) {
          return;
        }
        const res = await users.getAllUsers();
        this.users = res.result;
        localStorage.setItem('users', JSON.stringify(this.users));
        localStorage.setItem('users-cache-expiration', new Date().getTime() + 5 * 60 * 1000); // 5 minutes
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async getUsers(q) {
      try {
        this.loading = true;
        this.users = [];
        const res = await users.getUsers(this.page, q);
        this.users = await res.users;
        this.numberOfPages = await res.numberOfPages;
        this.loading = false;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    goToNextPage() {
      this.page = this.page + 1;
      this.getUsers();
    },
    goToPreviousPage() {
      if (this.page) {
        this.page = this.page - 1;
        this.getUsers();
      }
    },
    async getUsersById(id) {
      try {
        const res = await users.getUsersById(id);
        this.selectedUser = res;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async createUser(user) {
      try {
        const res = await users.createUser(user);
        this.users = [...this.users, res.result];
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async removeUser(id) {
      try {
        const res = await users.removeUser(id);
        // this.users = this.users.filter((u) => u._id !== id);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async updateUser(user) {
      try {
        const res = await users.updateUser(user);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async updateUserAsAdmin(id, user) {
      try {
        const res = await users.updateUserAsAdmin(id, user);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async updatePasswordAsAdmin(id, password) {
      try {
        const res = await users.updatePasswordAsAdmin(id, password);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async updatePassword(passwords) {
      try {
        const res = await users.updatePassword(passwords);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async signInAsUser(userId) {
      try {
        const res = await users.signInAsUser(userId);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  },
});

export default useUsers;
